import { useEffect, useRef } from 'react';
import { UseOutsideClickProps } from './types';

const ESCAPE_KEY_CODE = 27;

const EVENT_KEYDOWN = 'keydown';

const EVENT_MOUSEDOWN = 'mousedown';

export default function useOutsideClick(
  useOutsideClickProps: UseOutsideClickProps
) {
  const { handleOutside, refElement, ignoreRefElement } = useOutsideClickProps;

  const contentRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    contentRef.current = refElement?.current;

    const handleEscKey = (event: KeyboardEvent) => {
      if (event.keyCode === ESCAPE_KEY_CODE) {
        handleOutside();
      }
    };

    const handleOutsideClick = (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current.contains(event.target as Node) &&
        (!ignoreRefElement.current ||
          !ignoreRefElement.current.contains(event.target as Node))
      ) {
        handleOutside();
      }
    };

    document.addEventListener(EVENT_MOUSEDOWN, handleOutsideClick);
    document.addEventListener(EVENT_KEYDOWN, handleEscKey);

    return () => {
      document.removeEventListener(EVENT_MOUSEDOWN, handleOutsideClick);
      document.removeEventListener(EVENT_KEYDOWN, handleEscKey);
    };
  }, [handleOutside, refElement, ignoreRefElement]);
}
